import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus, Minus } from "lucide-react";
import { useT } from "@/context/LanguageContext";

export default function FAQ({ items = [] }) {
  const { t, ui } = useT();
  const [openIdx, setOpenIdx] = useState(0);

  return (
    <section className="relative bg-[color:var(--gcs-ivory-2)] py-24 md:py-40" data-testid="faq-section">
      <div className="mx-auto max-w-7xl px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16">
          <div className="md:col-span-4">
            <p className="overline text-[color:var(--gcs-gold)] mb-4">{ui("faq.chapter")}</p>
            <h2 className="font-serif text-4xl md:text-5xl leading-[1.02] tracking-tight text-[color:var(--gcs-emerald)]">
              {ui("faq.h1_a")}<em className="text-[color:var(--gcs-gold)]">{ui("faq.h1_em")}</em>{ui("faq.h1_b")}
            </h2>
          </div>
          <div className="md:col-span-8">
            <div className="divide-y divide-[color:var(--gcs-line)] border-y border-[color:var(--gcs-line)]">
              {items.map((f, i) => (
                <div key={f.id || i} className="py-6" data-testid={`faq-item-${i}`}>
                  <button
                    onClick={() => setOpenIdx(openIdx === i ? -1 : i)}
                    className="w-full flex items-start justify-between gap-6 text-left"
                    data-testid={`faq-toggle-${i}`}
                  >
                    <span className="font-serif text-xl md:text-2xl text-[color:var(--gcs-emerald)] leading-snug">
                      {t(f.question)}
                    </span>
                    <span className="mt-2 shrink-0 text-[color:var(--gcs-gold)]">
                      {openIdx === i ? <Minus className="w-5 h-5" /> : <Plus className="w-5 h-5" />}
                    </span>
                  </button>
                  <AnimatePresence initial={false}>
                    {openIdx === i && (
                      <motion.div
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: "auto", opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{ duration: 0.45, ease: [0.22, 1, 0.36, 1] }}
                        className="overflow-hidden"
                      >
                        <p className="mt-4 text-[color:var(--gcs-emerald)]/75 text-base md:text-lg leading-relaxed max-w-2xl">
                          {t(f.answer)}
                        </p>
                      </motion.div>
                    )}
                  </AnimatePresence>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
